import withRouter from 'Common/withRouter';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { changeLayoutMode } from "slices/thunk";
import { applyTheme, getStoredTheme } from "helpers/theme";

const NonAuthLayout = (props: any) => {

  const dispatch = useDispatch<any>();

  // Auth pages (Login/Register) honor the persisted light/dark theme too.
  useEffect(() => {
    const mode = getStoredTheme();
    applyTheme(mode);
    dispatch(changeLayoutMode(mode));
    document.documentElement.classList.add("scroll-smooth", "group");
    return () => {
      document.documentElement.classList.remove("scroll-smooth", "group");
    }
  }, [dispatch])

  return (
    <React.Fragment>{props.children}</React.Fragment>
  );
}

export default withRouter(NonAuthLayout)
